import React from 'react';

const Info = () => {
  return (
    <div>
        <p className='about-description-1'>
        Hello! I'm Shirley Nguyen. I recently graduated from University of California, Riverside with a degree in Computational Mathematics, and I'm now on the lookout for exciting opportunities as a software developer.
        </p>

        <p className='about-description-2'>
        Please explore my portfolio to see some of the projects I've worked on and get a sense of my coding style and problem-solving abilities. If you're interested in working together or have any questions, feel free to reach out to me.
        </p>

        <p className='about-description-3'>
        Here are a few technologies I’ve been working with recently:
        </p>

        <ul className='tech-list'>
            <li className='tech-item'>HTML5</li>

            <li className='tech-item'>CSS3</li>

            <li className='tech-item'>JavaScript</li>

            <li className='tech-item'>React</li>

            <li className='tech-item'>TypeScript</li>

            <li className='tech-item'>Node.js</li>
        </ul>
    </div>
  )
}

export default Info